module.exports = __webpack_public_path__ + "media/images/application/template/logo-new-143a6ca319195ae873e694f135a20618.svg";